export default "__VITE_ASSET__5gX3HbsR__"